import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MiniCarousel = ({ photos, categoryTitle }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (photos.length === 0) return;
    
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === photos.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(timer);
  }, [photos.length]);

  const goToPrevious = (e) => {
    e.stopPropagation();
    setCurrentIndex(currentIndex === 0 ? photos.length - 1 : currentIndex - 1);
  };

  const goToNext = (e) => {
    e.stopPropagation();
    setCurrentIndex(currentIndex === photos.length - 1 ? 0 : currentIndex + 1);
  };

  if (photos.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="relative h-[300px] overflow-hidden rounded-xl shadow-lg">
        {photos.map((photo, index) => (
          <div
            key={`${photo.url}-${index}`}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={photo.url}
              alt={photo.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
              <p className="text-white text-sm font-semibold">{photo.title}</p>
            </div>
          </div>
        ))}

        {photos.length > 1 && (
          <>
            <button
              onClick={goToPrevious}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-black p-2 rounded-full shadow-md transition-all z-10"
              aria-label="Photo précédente"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button
              onClick={goToNext}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-black p-2 rounded-full shadow-md transition-all z-10"
              aria-label="Photo suivante"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </>
        )}
      </div>
      
      <div className="flex justify-center gap-1.5 mt-3">
        {photos.map((photo, index) => (
          <button
            key={`mini-indicator-${photo.url}-${index}`}
            onClick={(e) => {
              e.stopPropagation();
              setCurrentIndex(index);
            }}
            className={`w-2 h-2 rounded-full transition-all ${
              index === currentIndex 
                ? 'bg-orange-600 w-4' 
                : 'bg-gray-400 hover:bg-gray-500'
            }`}
            aria-label={`Aller à la photo ${index + 1}`}
          />
        ))}
      </div>
      
      <p className="text-center text-gray-600 text-sm mt-2">
        {currentIndex + 1} / {photos.length} photos
      </p>
    </div>
  );
};

export default MiniCarousel;
